import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectStyles } from 'injectStyles';
import * as cssVariable from 'cssVariables';
import classNames from 'classnames';
import SVG from 'react-inlinesvg';
import IconHome from 'components/svg/Home';
import IconRadio from 'components/svg/RadioIcon';
import IconShow from 'components/svg/Show';
import IconGenre from 'components/svg/Genre';
import IconMusic from 'components/svg/Music';
import IconCrown from 'components/svg/CrownOutline';
import IconPodcast from 'components/svg/Podcast';
import IconTerugluisteren from 'components/svg/Terugluisteren';
import logger from 'util/logger';

const ICONS = {
  IconHome,
  IconRadio,
  IconShow,
  IconGenre,
  IconMusic,
  IconCrown,
  IconPodcast,
  IconTerugluisteren,
};

class NavigationItem extends PureComponent {
  static defaultProps = {
    hasSmallDesktopMenu: false,
    isNew: false,
    navIsExpanded: false,
    isCollapsible: false,
  };

  static propTypes = {
    hasSmallDesktopMenu: PropTypes.bool,
    isNew: PropTypes.bool,
    icon: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired,
    navIsExpanded: PropTypes.bool,
    isCollapsible: PropTypes.bool,
  };

  createIcon = (icon) => {
    if (icon) {
      return React.createElement(ICONS[icon]);
    }
    return null;
  };

  render() {
    const { hasSmallDesktopMenu, icon, title, isNew, classes, navIsExpanded, isCollapsible } = this.props;

    const showNewLabel = isNew && !hasSmallDesktopMenu;

    const newLabelClass = classNames(classes.newLabel, classes.redColor, {
      [classes.fadeIn]: navIsExpanded,
      [classes.newLabelCollapsibleNav]: isCollapsible,
    });

    return (
      <Fragment>
        <span
          className={classNames(classes.iconContainer, {
            [classes.smallIcon]: hasSmallDesktopMenu,
          })}
        >
          {icon && icon.iconUrl && (
            <SVG
              src={icon.iconUrl}
              onError={(e) => {
                logger.error(e);
              }}
            />
          )}
          {icon && !icon.iconUrl && this.createIcon(icon.iconType)}
        </span>
        {hasSmallDesktopMenu ? null : (
          <span
            className={classNames(classes.label, {
              [classes.fadeIn]: navIsExpanded,
              [classes.labelCollapsibleNav]: isCollapsible,
            })}
          >
            {title}
          </span>
        )}
        {showNewLabel && <span className={newLabelClass}>NIEUW</span>}
      </Fragment>
    );
  }
}

const styles = (theme) => ({
  iconContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexBasis: 50,
    '& svg': {
      width: 30,
      height: 30,
      pointerEvents: 'none',
    },
  },

  label: {
    maxWidth: 'calc(100% - 75px)',
    flexGrow: 1,
    textTransform: 'uppercase',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: cssVariable.fontWeights.regular,
    margin: 0,
    paddingLeft: 0,
    fontSize: cssVariable.fontSizes.xsmall,
  },
  newLabel: {
    position: 'absolute',
    right: 20,
    top: 14,
    borderRadius: 2,
    color: cssVariable.white,
    fontSize: cssVariable.fontSizes.xxsmall,
    fontWeight: cssVariable.fontWeights.bold,
    height: 20,
    width: 45,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: cssVariable.red500,
  },

  '@keyframes fadeIn': {
    '0%': { opacity: '0' },
    '100%': { opacity: '1' },
  },
  fadeIn: {
    opacity: 0,
    animation: '$fadeIn 500ms forwards',
    animationDelay: '200ms',
  },

  labelCollapsibleNav: {},
  newLabelCollapsibleNav: {},
  [theme.breakpoints.down('sl')]: {
    label: {
      paddingLeft: 8,
      fontSize: cssVariable.fontSizes.medium,
    },
    newLabel: {
      top: 24,
    },

    labelCollapsibleNav: {
      paddingLeft: 0,
      fontSize: cssVariable.fontSizes.xsmall,
    },

    newLabelCollapsibleNav: {
      top: 14,
    },
  },
  smallIcon: {
    '& $label': {
      fontWeight: cssVariable.fontWeights.regular,
    },
  },
});

export default injectStyles(styles)(NavigationItem);
